import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaPaperPlane, FaDesktop, FaUsers, FaBullhorn, FaSearchDollar, FaMobileAlt, FaCamera, FaEnvelopeOpenText, FaWordpress, FaServer, FaTrademark, FaGoogle, FaEnvelope } from 'react-icons/fa';
import * as S from '../styles';

function HomePage({
  testimonials,
  currentTestimonial,
  prevTestimonial,
  handleDotClick,
  formRef,
  formData,
  handleInputChange,
  handleSubmit,
  isSubmitting
}) {
  const navigate = useNavigate();

  return (
    <>
      <S.Hero id="home">
        <S.VideoBackground autoPlay loop muted playsInline>
          <source src="/media/demirer-ajans-office.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </S.VideoBackground>
        <S.Title
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Dijital Dünyada<br />Öne Çıkın
        </S.Title>
        <S.Subtitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Modern ve etkileyici web çözümleriyle markanızı geleceğe taşıyoruz
        </S.Subtitle>

        <S.CTAButton
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/services')}
        >
          Projelerimizi Keşfedin
        </S.CTAButton>
      </S.Hero>

      <S.Services id="services">
        <S.SectionTitle>Hizmetlerimiz</S.SectionTitle>
        <S.SectionSubtitle>
          Dijital dünyada işinizi büyütmek için sunduğumuz kapsamlı hizmetler.
        </S.SectionSubtitle>
        <S.ServicesGrid>
          <S.ServiceCard
            as={Link}
            to="/services/kurumsal-web-tasarim"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaDesktop size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Kurumsal Web Tasarım</h3>
            <p>Şirketinizin dijital varlığını güçlendirecek modern ve kullanıcı dostu web siteleri tasarlıyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/mobil-uygulama"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaMobileAlt size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Mobil Uygulama</h3>
            <p>İşletmenize özel, kullanıcı dostu ve yenilikçi mobil uygulamalar geliştiriyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/fotograf-cekimi"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaCamera size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Fotoğraf Çekimi</h3>
            <p>Ürünleriniz ve hizmetleriniz için profesyonel fotoğraf çekimi hizmetleri sunuyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/sunucu-hizmetleri"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaServer size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Sunucu Hizmetleri</h3>
            <p>Yüksek performanslı, güvenli ve ölçeklenebilir sunucu çözümleri ile işletmenizin dijital altyapısını güçlendiriyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/marka-tescil-hizmeti"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaTrademark size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Marka Tescil Hizmeti</h3>
            <p>Markanızı koruma altına alıyor, tescil süreçlerinizi profesyonel bir şekilde yönetiyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/google-isletme-kaydi"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaGoogle size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Google İşletme Kaydı</h3>
            <p>Google My Business hesabınızı oluşturup yöneterek, yerel aramalarda öne çıkmanızı sağlıyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/sosyal-medya-yonetimi"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaUsers size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Sosyal Medya Yönetimi</h3>
            <p>Markanızın sosyal medyadaki varlığını güçlendiriyor, hedef kitlenizle etkileşimi artırıyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/performans-odakli-seo"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaSearchDollar size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Performans Odaklı SEO</h3>
            <p>Arama motorlarında üst sıralara çıkarak organik trafiğinizi ve marka bilinirliğinizi artırıyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/wordpress-hizmetleri"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaWordpress size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>WordPress Hizmetleri</h3>
            <p>WordPress tabanlı web siteleriniz için özelleştirme, bakım ve güvenlik hizmetleri sunuyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/kurumsal-mail-hizmeti"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaEnvelope size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Kurumsal Mail Hizmeti</h3>
            <p>Profesyonel ve güvenli e-posta çözümleriyle kurumsal iletişiminizi sorunsuz hale getiriyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/e-posta-pazarlama"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaEnvelopeOpenText size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>E-Posta Pazarlama</h3>
            <p>Hedef kitlenize ulaşan, etkili e-posta kampanyaları ile satışlarınızı artırıyoruz.</p>
          </S.ServiceCard>
          <S.ServiceCard
            as={Link}
            to="/services/reklam-yonetimi"
            whileHover={{ y: -10, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <FaBullhorn size={40} style={{ marginBottom: '1rem', color: '#00B4DB' }} />
            <h3>Reklam Yönetimi</h3>
            <p>Google Ads ve sosyal medya reklamlarıyla hedef kitlenize ulaşarak dönüşümlerinizi artırıyoruz.</p>
          </S.ServiceCard>
        </S.ServicesGrid>
      </S.Services>

      <S.TestimonialsSection id="testimonials">
        <S.SectionTitle>Müşteri Yorumları</S.SectionTitle>
        <S.SectionSubtitle>
          Müşterilerimizin başarı hikayeleri bizim için en büyük ilham kaynağı.
        </S.SectionSubtitle>
        <S.TestimonialCarousel>
          {testimonials.map((testimonial, index) => (
            <S.TestimonialSlide
              key={index}
              className={`${index === currentTestimonial ? 'active' : ''} ${
                index === prevTestimonial ? 'prev' : ''
              }`}
            >
              <S.TestimonialCard>
                <p>{testimonial.text}</p>
                <h4>{testimonial.author}</h4>
                <span>{testimonial.role}</span>
              </S.TestimonialCard>
            </S.TestimonialSlide>
          ))}
        </S.TestimonialCarousel>
        <S.TestimonialDots>
          {testimonials.map((_, index) => (
            <S.TestimonialDot
              key={index}
              active={index === currentTestimonial}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </S.TestimonialDots>
      </S.TestimonialsSection>

      <S.ContactSection id="contact">
        <S.ContactContent>
          <S.ContactTitle>Sizi Arayalım</S.ContactTitle>
          <S.ContactForm ref={formRef} onSubmit={handleSubmit}>
            <S.ContactInput
              type="text"
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
            <S.ContactInput
              type="tel"
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required
            />
            <S.SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Gönderiliyor...' : <FaPaperPlane />}
            </S.SubmitButton>
          </S.ContactForm>
        </S.ContactContent>
      </S.ContactSection>
    </>
  );
}

export default HomePage;
